import { createPathFromRoute } from 'assets/utils/dom/UrlParsing';
import executeServerApi from 'assets/utils/server/ServerApi';
import { getDefaultHeaders, HttpMethod } from 'config/Api.Config';

type Request = Api.Core.ProductPricingPlan.Import.IRequest;
type Headers = Api.Core.ProductPricingPlan.Import.IHeaders;
type Response = Api.Core.ProductPricingPlan.Import.IResponse;
const url = '/api/ProductManagement/ProductPricingPlan/ImportFromExcel/:productId';
export async function productPricingPlanImportFromExcelApi(body: Request): Promise<Api.Res<Response>> {
  const serverResponse = await executeServerApi<Request, Response, Headers>({
    method: HttpMethod.put,
    body,
    url: createPathFromRoute(url, { productId: body.productId }, null),
    headers: getDefaultHeaders(),
  });
  return serverResponse;
}
